export default "__VITE_PUBLIC_ASSET__1f30c3a4__"